export default "__VITE_ASSET__WpIxhJGk__"